// * 请求枚举配置
/**
 * @description：请求配置
 */
export enum ResultEnum {
	SUCCESS = 0,
	INVALIDUSER = 100,
	INVALIDOWNER = 4004,
	MISSOWNER = 4002,
	ERROR = 500,
	OVERDUE = 4031,
	TIMEOUT = 10000,
	NOLOGIN = 4030,
	TYPE = 'success'
}
/**
 * @description：请求方法
 */
export enum RequestEnum {
	GET = 'GET',
	POST = 'POST',
	PATCH = 'PATCH',
	PUT = 'PUT',
	DELETE = 'DELETE'
}
export enum  LongDateFormat  {
	HM = 'HH:mm',
	HMS = 'HH:mm:ss',
	YMDIOS = 'YYYY/MM/DD',
	YMD = 'YYYY-MM-DD',
	YMDHMSIOS=  'YYYY/MM/DD HH:mm:ss',
	YMDHMS=  'YYYY-MM-DD HH:mm:ss',
	LOCAL = 'YYYY年MM月DD日'
}